// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

import { useFloating, offset, flip } from '@floating-ui/react-dom';
import { Z_INDEX_TOOLTIP } from '../../constants';
import { useEscapeKeydown } from '../../hooks/useEscapeKeydown';
import Layer from '../Layer';
import { jsx as _jsx } from "react/jsx-runtime";
const isVirtualElement = element => element !== null && !(element instanceof HTMLElement);
export const TooltipContent = _ref => {
  let {
    title,
    visible,
    virtualElement,
    trigger,
    onEscapeKeyDown,
    className,
    style,
    id,
    ...props
  } = _ref;
  useEscapeKeydown(onEscapeKeyDown);
  const {
    refs,
    floatingStyles
  } = useFloating({
    middleware: [offset(_ref2 => {
      let {
        placement,
        elements
      } = _ref2;
      if (!isVirtualElement(elements.reference)) {
        return {
          mainAxis: 8
        };
      }
      const [side] = placement.split('-');
      return {
        mainAxis: side === 'bottom' ? 16 : 8,
        alignmentAxis: 8
      };
    }), flip(_ref3 => {
      let {
        elements
      } = _ref3;
      let fallbackPlacements = ['bottom-end', 'bottom', 'top-start', 'top-end', 'top'];
      if (!isVirtualElement(elements.reference)) {
        fallbackPlacements = ['top-start', 'top-end', 'bottom', 'bottom-start', 'bottom-end', 'right', 'left'];
      }
      return {
        padding: 5,
        fallbackPlacements
      };
    })],
    placement: virtualElement ? 'bottom-start' : 'top',
    elements: {
      reference: virtualElement ? virtualElement : trigger
    }
  });
  return /*#__PURE__*/_jsx(Layer, {
    level: Z_INDEX_TOOLTIP,
    children: /*#__PURE__*/_jsx("span", {
      ref: refs.setFloating,
      id: id,
      className: className,
      style: {
        ...style,
        visibility: visible ? 'visible' : 'hidden',
        ...floatingStyles
      },
      role: "tooltip",
      ...props,
      children: title
    })
  });
};